/* eslint-disable react-hooks/rules-of-hooks */

import { handleVersionMismatch } from 'actions/versionSync';
import { VersionMismatch } from 'services/BaseService';
import * as StoryletActionTypes from '../../actiontypes/storylet';
import StoryletService from 'services/StoryletService';

import fetchAvailable from 'actions/storylet/fetchAvailable';

const service = new StoryletService();

/** ----------------------------------------------------------------------------
 * USE QUALITY
 -----------------------------------------------------------------------------*/
export default function useQuality(id: number, history: any) {
  return (dispatch: Function) => {
    dispatch(useQualityRequested());
    service.useQuality(id)
      .then((response: { data: any }) => {
        if (response.data.isSuccess) {
          dispatch(useQualitySuccess());
          dispatch(fetchAvailable());
          history.push('/');
        } else {
          dispatch(cannotUseQuality(response.data));
        }
      }).catch((error) => {
      console.error(error);
      if (error instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(error));
      }
      dispatch(useQualityFailure(error));
    });
  };
}

const useQualityRequested = () => ({
  type: StoryletActionTypes.USE_QUALITY_REQUESTED,
  isFetching: true,
});

const useQualitySuccess = () => ({
  type: StoryletActionTypes.USE_QUALITY_SUCCESS,
  isFetching: false,
});

const useQualityFailure = (error: any) => ({
  type: StoryletActionTypes.USE_QUALITY_FAILURE,
  isFetching: false,
  error: true,
  status: error.response && error.response.status,
});

const cannotUseQuality = (data: { message: string }) => ({
  type: StoryletActionTypes.CANNOT_USE_QUALITY,
  isFetching: false,
  cannotUseMessage: data.message,
});